import { StyledFlex } from '@tryhackme/thm-ui-components';
import { StyledLoading } from './loading.styles';
export const Loading = () => <>
    <StyledLoading width="9rem" height="9rem" mobileHeight="6rem" mobileWidth="6rem" data-testid="loading" data-sentry-element="StyledLoading" data-sentry-source-file="loading.tsx" />
    <div>
      <StyledFlex justifyContent="flex-start" alignItems="center" data-sentry-element="StyledFlex" data-sentry-source-file="loading.tsx">
        <StyledLoading width="35rem" height="3.7rem" margin="0 0 1rem 0" mobileWidth="15rem" data-sentry-element="StyledLoading" data-sentry-source-file="loading.tsx" />
        <StyledLoading width="22.8rem" height="2rem" mobileWidth="10rem" mobileHeight="1.5rem" data-sentry-element="StyledLoading" data-sentry-source-file="loading.tsx" />
      </StyledFlex>
      <StyledLoading width="70rem" height="2rem" mobileWidth="35rem" mobileHeight="1.8rem" data-sentry-element="StyledLoading" data-sentry-source-file="loading.tsx" />
    </div>
  </>;